// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KRlb","comment":"styles_comment__3KdbT"};